import { NotificationsListView } from "@/components/Templates/Notifications";

const Notifications = () => {
	return <NotificationsListView />;
};

export default Notifications;
